<template>
  <div class="container-auditor">
		<div class="item" v-for="(v, index) in list" :key="index">
			<!-- 第一个元素 -->
			<template v-if="index === 0">
				<div class="box">
					<i class="icon" :class="index === 0 ? 'icon-audit-touxiang66dark' : 'icon-audit-touxiang66'"></i>
					<template v-if="v.selfFlag">
						<el-tooltip effect="dark" :content="v.userName + '(我)'" placement="bottom">
							<div class="auditor">{{v.userName + '(我)'}}</div>
						</el-tooltip>
					</template>
					<template v-else>
						<el-tooltip effect="dark" :content="v.userName" placement="bottom">
							<div class="auditor">{{v.userName}}</div>
						</el-tooltip>
					</template>
					<!-- -5 -->
					<template v-if="v.signStatus === -5">
						<div class="status text-color-red">已撤销</div>
						<div class="time">{{v.updateTime}}</div>
					</template>
          <template v-if="v.signStatus === -6">
            <div class="status text-color-red">已失效</div>
            <div class="time">{{v.updateTime}}</div>
          </template>
					<template v-else>
						<div class="status text-color-green">发起申请</div>
						<div class="time">{{v.createTime}}</div>
					</template>
				</div>
				<div class="audit-arrow-body">
					<i class="icon icon-audit-jiantou32"></i>
				</div>
			</template>
			<!-- 其它元素 -->
			<template v-else>
				<div class="box">
					<i class="icon" :class="index === 0 ? 'icon-audit-touxiang66dark' : 'icon-audit-touxiang66'"></i>
					<template v-if="v.selfFlag">
						<el-tooltip effect="dark" :content="v.userName + '(我)'" placement="bottom">
							<div class="auditor">{{v.userName + '(我)'}}</div>
						</el-tooltip>
					</template>
					<template v-else>
						<el-tooltip effect="dark" :content="v.userName" placement="bottom">
							<div class="auditor">{{v.userName}}</div>
						</el-tooltip>
					</template>


					<div class="status text-color-green" v-if="v.flowStatus === 1">已同意</div>
					<div class="status text-color-red" v-if="v.flowStatus === 2">已驳回</div>
					<div class="status" v-if="v.flowStatus === 0">未审批</div>

					<div class="time" v-if="v.flowTime">{{v.flowTime}}</div>
					<el-tooltip v-if="v.refuseReason" placement="top">
						<div slot="content">{{v.refuseReason}}</div>
						<div class="reason">拒绝原因</div>
					</el-tooltip>
				</div>
				<div v-if="isOrder" class="audit-arrow-body">
					<i v-if="index !== list.length-1" class="icon icon-audit-jiantou32"></i>
				</div>
			</template>
		</div>
  </div>
</template>

<script>
export default {
  name: "audit-detail",
  props: {
    auditor: {
			type: Object,
			defualt: null
    }
  },
  data() {
    return {
			list: [],
			isOrder: true, // true 顺序签 false 会审
		};
  },
  components: {},
  created() {},
  watch: {
		auditor(newVal) {
			if (!newVal) {
				return
			}
			this.list = this.auditor.instPartyList
			this.isOrder = this.auditor.orderNum
			// 发起人
			let v = {}
			v.userName = this.auditor.initiateName
			v.createTime = this.auditor.createTime
			v.signStatus = this.auditor.signStatus
			v.updateTime = this.auditor.updateTime
			this.list.splice(0, 0, v)
		}
	},
  computed: {},
  mounted() {},
  methods: {
		/**
		 * 自动换行
		 * @param v 值
		 * @param number
		 */
		autoNewLine(v, number) {
			let d = ''
			for (let index = 0; index < v.length; index++) {
				const element = v[index];
				if (index > 0 && index % number === 0) {
					d += '\r\n'
				}
				d += element
			}
			return d
		}
	},
  beforeDestroy() {}
};
</script>
<style>
	.el-tooltip__popper{
		max-width: 300px;
		white-space: normal;
		word-break: break-all;
	}
</style>
<style scoped>
.container-auditor{
	width: 100%;
	height: 220px;
	overflow-x: auto;
	overflow-y: hidden;
	white-space: nowrap;
}
.container-auditor .item{
	display:inline-block;
	box-sizing: border-box;
	height: 100%;
}

.box {
	width: 78px;
	float: left;
	text-align: center;
	margin: 0 10px;
	position: relative;
}
.box i {
	width: 48px;
	height: 48px;
}
.box .auditor {
	margin-top: 6px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.box .auditor, .box .status, .box .time, .box .reason{
	font-size: 12px;
	color: #646464;
	padding: 6px 0;
}
.box .time {
	white-space: normal;
}
.box .reason{
	background: red;
	color: #ffffff;
}


.audit-arrow-body {
	float: left;
	width: 30px;
	height: 220px;
	text-align: center;
	padding-top: 15px;
}
.audit-arrow-body i {
	width: 28px;
	height: 22px;
}
.audit-add {
	float: left;
	width: 78px;
	height: 78px;
	text-align: center;
	margin: 0 10px;
	cursor: pointer;
}
.audit-add i {
	width: 78px;
	height: 78px;
}
.box .text-color-red {
	color: red;
}
.box .text-color-green {
	color: #009899;
}
</style>



// WEBPACK FOOTER //
// components/auditDetail/index.vue